<template>
  <v-container>
      <v-row justify="center" alignment="center" no-gutters>
          <v-col cols="1">
              <v-img
                :src="lashesLeft.src"
                contain
                :max-height="lashHeight"
                class="jog-down float-right margin-sm-right"
                :class="{'padded-top-sm': $vuetify.breakpoint.mdAndDown}"
              ></v-img>
          </v-col>
          <v-col cols="9" class="text-white heading-block">
              <div class="green-slant"><h1 class="center-text arla-strong" :class="{'small-heading': $vuetify.breakpoint.mdAndDown}">{{heading}}</h1></div>
          </v-col>
          <v-col cols="1">
              <v-img
                :src="lashesRight.src"
                contain
                :max-height="lashHeight"
                class="jog-down float-left margin-sm-left"
                :class="{'padded-top-sm': $vuetify.breakpoint.mdAndDown}"
              ></v-img>
          </v-col>
      </v-row>
      <v-row justify="center" alignment="center">
        <v-col cols="auto" class="text-green">
          <p class="text-center" v-html="introText"></p>
          <span v-html="termsData.payload[0].contents"></span>
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
  export default {
    props: ['termsData', 'langData'],
    created() {
      console.log(this.termsData)
    },
    data: (el = this) => ({
      name : 'terms',
      heading: el.langData.terms.title,
      introText: el.langData.terms.body,
      lashesRight : {src:require('../assets/lashesRight.png')},
      lashesLeft : {src:require('../assets/lashesLeft.png')},
      lashHeight: '38px',
    })
  }
</script>
<style scoped>
  h1.center-text.arla-strong {
    font-size: 16px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
</style>